<script>
import bem from '@/utils/bem';
import constants from '@/constants/index';
import { ColorPicker } from 'vue3-colorpicker';

const {
  FONT_WEIGHT_OPTIONS,
  FONT_FAMILY_OPTIONS,
  ALIGNMENT_OPTIONS,
  VERTICAL_ALIGNMENT_OPTIONS,
} = constants;

const b = bem('template-frame-option-displays');

export default {
  components: { ColorPicker },
  data() {
    return {
      FONT_WEIGHT_OPTIONS,
      FONT_FAMILY_OPTIONS,
      ALIGNMENT_OPTIONS,
      VERTICAL_ALIGNMENT_OPTIONS,
      activeKey: ['1'],
    };
  },
  props: {
    frameDisplayPersonalize: Array,
    selectedPersonalize: Object,
    scale: Number,
    onChange: Function,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
  },
};
</script>

<template>
  <div
      :class="b('view-personalize', {
        show: selectedPersonalize.id && selectedPersonalize.id === personalize.id
      })"
      v-for="(personalize) in frameDisplayPersonalize"
      :key="personalize.id"
  >
    <!-- Zone name — always visible at top, moved from the old scale=1 block -->
    <div :class="b('row')" style="margin-bottom: 12px;">
      <div :class="b('modal-input', { row: true, full: true })">
        <span :class="b('modal-input-title')">Zone name:</span>
        <a-input
            type="text"
            v-model:value="personalize.name"
        />
      </div>
    </div>
    <!-- Full settings always shown — no more scale=1 vs zoomed split -->
      <a-collapse
        v-model:activeKey="activeKey"
        :bordered="false"
        expand-icon-position="end"
        :class="b('collapse')"
      >
        <!-- Position -->
        <a-collapse-panel key="1" header="Position">
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">X:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.x"
              />
            </div>
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Y:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.y"
              />
            </div>
          </div>
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Width:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.width"
              />
            </div>
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Height:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.height"
              />
            </div>
          </div>
        </a-collapse-panel>

        <!-- Typography -->
        <a-collapse-panel key="2" header="Typography">
          <div :class="b('modal-input')">
            <span :class="b('modal-input-title')">Font family:</span>
            <a-select
                :class="b('select', { full: true })"
                :options="FONT_FAMILY_OPTIONS"
                placeholder="Select font family"
                v-model:value="personalize.fontFamily"
                show-search
                :filter-option="filterOption"
                not-found-content="Not Found"
            />
          </div>
          <div :class="b('modal-input')">
            <span :class="b('modal-input-title')">Font weight:</span>
            <a-select
                :class="b('select', { full: true })"
                :options="FONT_WEIGHT_OPTIONS"
                placeholder="Select font weight"
                v-model:value="personalize.fontWeight"
            />
          </div>
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Font size:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.fontSize"
              />
            </div>
          </div>
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Font color:</span>
              <ColorPicker
                  v-model:pureColor="personalize.fontColor"
              />
            </div>
          </div>
          <div :class="b('modal-input')">
            <span :class="b('modal-input-title')">Alignment:</span>
            <a-select
                :class="b('select', { full: true })"
                :options="ALIGNMENT_OPTIONS"
                placeholder="Select alignment"
                v-model:value="personalize.alignment"
            />
          </div>
          <div :class="b('modal-input')">
            <span :class="b('modal-input-title')">Vertical alignment:</span>
            <a-select
                :class="b('select', { full: true })"
                :options="VERTICAL_ALIGNMENT_OPTIONS"
                placeholder="Select vertical alignment"
                v-model:value="personalize.verticalAlignment"
            />
          </div>
        </a-collapse-panel>

        <!-- Text Content -->
        <a-collapse-panel key="3" header="Text Content">
          <div :class="b('modal-input')">
            <span :class="b('modal-input-title')">Placeholder:</span>
            <a-input
                type="text"
                v-model:value="personalize.placeholder"
            />
          </div>
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Char limit:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.characterLimit"
              />
            </div>
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Lines:</span>
              <a-input
                  type="number"
                  :value="personalize.lineLimit"
                  @change="({ target: { value } }) => {
                    onChange({
                      value,
                      type: 'lineLimit'
                    })
                  }"
              />
            </div>
          </div>
          <div
              :class="b('text-line-item')"
              v-for="(line, idx) in personalize.lines"
              :key="line.id"
          >
            <span :class="b('text-line-header')">Line #{{ idx + 1 }}</span>
            <a-input
                v-if="!line.isTextArea"
                type="text"
                :maxlength="personalize.characterLimit"
                v-model:value="line.value"
                placeholder="Text value"
            />
            <a-textarea
                v-else
                :maxlength="personalize.characterLimit"
                v-model:value="line.value"
                :auto-size="{ minRows: 2, maxRows: 4 }"
                placeholder="Text value"
            />
            <a-input
                type="text"
                v-model:value="line.placeholder"
                placeholder="Placeholder"
                style="margin-top: 6px;"
            />
            <div :class="b('text-line-switch')">
              <span>Text area</span>
              <a-switch
                  v-model:checked="line.isTextArea"
                  size="small"
              />
            </div>
          </div>
        </a-collapse-panel>

        <!-- Display Options -->
        <a-collapse-panel key="4" header="Display Options">
          <div :class="b('toggle-grid')">
            <div :class="b('toggle-item')">
              <span>Preview</span>
              <a-switch
                  v-model:checked="personalize.isPersonalizeDisplayPreview"
                  size="small"
              />
            </div>
            <div :class="b('toggle-item')">
              <span>Required</span>
              <a-switch
                  v-model:checked="personalize.isRequired"
                  size="small"
              />
            </div>
            <div :class="b('toggle-item')">
              <span>Uppercase</span>
              <a-switch
                  v-model:checked="personalize.isUppercase"
                  size="small"
              />
            </div>
            <div :class="b('toggle-item')">
              <span>Active</span>
              <a-switch
                  v-model:checked="personalize.isPersonalizeActive"
                  size="small"
              />
            </div>
          </div>
        </a-collapse-panel>

        <!-- Frame Position -->
        <a-collapse-panel key="5" header="Frame Position">
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">X:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.framePersonalizeOptions.x"
              />
            </div>
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Y:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.framePersonalizeOptions.y"
              />
            </div>
          </div>
          <div :class="b('row')">
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Width:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.framePersonalizeOptions.width"
              />
            </div>
            <div :class="b('modal-input', { row: true })">
              <span :class="b('modal-input-title')">Height:</span>
              <a-input
                  type="number"
                  v-model:value="personalize.framePersonalizeOptions.height"
              />
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
  </div>
</template>

<style scoped lang="scss" src="./templateFrameOptionDisplays.scss"></style>
